import { FiArrowUpRight, FiArrowDownRight } from "react-icons/fi";

export default function StatCard({
  title,
  value,
  subtitle,
  icon,
  bgColor = "text-primary-700",
  iconBg = "bg-primary-100",
  trend = "up",
  trendValue = "",
}) {
  return (
    <div
      className="
        group
        relative
        overflow-hidden
        bg-white
        rounded-3xl
        border
        border-gray-100
        p-6
        hover:shadow-xl
        hover:-translate-y-1
        transition-all
        duration-300
      "
    >
      {/* Background Decoration */}

      <div
        className="
          absolute
          -right-10
          -top-10
          h-36
          w-36
          rounded-full
          bg-gradient-to-br
          from-primary-50
          to-transparent
        "
      />

      {/* Top */}

      <div className="relative flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500">
            {title}
          </p>

          <h2 className="mt-3 text-4xl font-bold tracking-tight text-gray-900">
            {value}
          </h2>
        </div>

        <div
          className={`
            h-14
            w-14
            rounded-2xl
            flex
            items-center
            justify-center
            shadow-sm
            ${iconBg}
          `}
        >
          <div className={bgColor}>{icon}</div>
        </div>
      </div>

      {/* Bottom */}

      <div className="relative mt-6 flex items-center justify-between">
        <p className="text-sm text-gray-500">
          {subtitle}
        </p>

        {trendValue && (
          <div
            className={`
              flex
              items-center
              gap-1
              rounded-full
              px-2.5
              py-1
              text-xs
              font-semibold
              ${
                trend === "up"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }
            `}
          >
            {trend === "up" ? (
              <FiArrowUpRight size={14} />
            ) : (
              <FiArrowDownRight size={14} />
            )}

            {trendValue}
          </div>
        )}
      </div>

      {/* Hover Line */}

      <div
        className="
          absolute
          bottom-0
          left-0
          h-1
          w-0
          bg-primary-700
          transition-all
          duration-300
          group-hover:w-full
        "
      />
    </div>
  );
}